module.exports = __webpack_public_path__ + "media/images/upload_icon-2dad6f50d5957da746f3d47088a8ad7b.svg";